
import { useState } from 'react';
import { useAdministracaoStore } from '../../stores/administracao/administracao';
import { useLocation, useNavigate } from 'react-router';
import { tv } from 'tailwind-variants'
import { ModuloComTelas, Tela } from '../../types/administracao/administracaoTypes';
import { Icon } from '@mui/material';

import * as MuiIcons from '@mui/icons-material';
import DynamicIcon from './DynamicIcon';

function NavBarItems({ isCollapsed, setIsCollapsed }: { isCollapsed: boolean, setIsCollapsed: React.Dispatch<React.SetStateAction<boolean>> }) {
  const { screensPermissions } = useAdministracaoStore()
  const path = useLocation().pathname
  const navigate = useNavigate()

  const dashboard: ModuloComTelas = {
    idModuloSistema: 0,
    descricao: 'Dashboard',
    urlTelas: ["/dashboard", "/"],
    icone: undefined,
  }

  const getNameIcon = (descricaoModulo: string): keyof typeof MuiIcons => {
    let name: keyof typeof MuiIcons = "DoNotDisturbRounded"
    if (descricaoModulo === "Dashboard") {
      name = "DashboardRounded"
    }
    if (descricaoModulo === "RH") {
      name = "GroupsRounded"
    }
    if (descricaoModulo === "Administração") {
      name = "ManageAccounts"
    }
    return name
  }

  const { iconColor } = tv({
    slots: {
      iconColor: ""
    },
    variants: {
      moduleActive: {
        true: {
          iconColor: "text-white"
        },
        false: {
          iconColor: "text-text-gray dark:text-white"
        }
      }
    }
  })()

  const { bg } = tv({
    slots: {
      bg: "w-full min-h-12 flex items-center rounded-[4px] cursor-pointer gap-2"
    },
    variants: {
      style: {
        collapsed: {
          bg: "justify-center hover:bg-hover-light-mode dark:hover:bg-hover-dark-mode"
        },
        notCollapsed: {
          bg: "justify-between py-2 px-3 hover:bg-hover-light-mode dark:hover:bg-hover-dark-mode"
        },
        activeCollapsed: {
          bg: "justify-center bg-primary-green hover:bg-hover-primary-green text-white"
        },
        activeNotCollapsed: {
          bg: "justify-between py-2 px-3 bg-primary-green hover:bg-hover-primary-green text-white"
        }
      }
    }
  })()

  const moduleActive = (modulo: ModuloComTelas) => {
    if (modulo.urlTelas?.some(x => x === path && modulo.idModuloSistema === 0)) {
      return true
    }
    return false
  }

  const RenderScreen = ({ screen }: { screen: Tela }) => {
    const [isOpen, setIsOpen] = useState(screen.telasFilhas?.some(x => x.url === path || x.telasFilhas.some(y => y.url === path)));
    return (
      <>
        {
          isCollapsed === false &&
          <div className={`flex flex-col`}>
            <div
              onMouseDown={(e) => {
                if (e.button === 1) {
                  if (screen.telasFilhas.length > 0 && screen.telasFilhas.some(x => x.exibir === true && x.menuPrincipal === true)) {
                    setIsOpen(!isOpen)
                  }
                  else {
                    if (screen.url) {
                      window.open(screen.url, '_blank', 'noopener,noreferrer');
                    }
                  }
                }
                e.preventDefault();
              }}
              onClick={(e) => {
                if (screen.telasFilhas.length > 0 && screen.telasFilhas.some(x => x.exibir === true && x.menuPrincipal === true)) {
                  setIsOpen(!isOpen)
                }
                else {
                  if (screen.url) {
                    if (e.ctrlKey) {
                      window.open(screen.url, '_blank', 'noopener,noreferrer');
                    } else {
                      navigate(screen.url)
                    }
                  }
                }
              }}>
              <div className={bg({ style: (screen.url && screen.url === path) || screen.telasFilhas.some(x => x.url && x.url === path && x.exibir === false && x.menuPrincipal === false) ? "activeNotCollapsed" : "notCollapsed" })}>
                <div className={`w-full flex justify-between ${screen.idTelaPai === null ? "" : "pl-4 text-sm font-medium"}`}>
                  <div className={`flex items-center overflow-hidden`}>
                    {
                      isCollapsed === false &&
                      <p className=''>{screen.nomeTela}</p>
                    }
                  </div>
                  {
                    (screen.telasFilhas.length > 0 && screen.telasFilhas.some(x => x.exibir === true && x.menuPrincipal === true)) &&
                    <div>
                      <DynamicIcon nameIcon={isOpen ? "KeyboardArrowDownRounded" : "KeyboardArrowRightRounded"} size={25} className={iconColor({ moduleActive: false })} />
                    </div>
                  }
                </div>
              </div>
            </div >
            {
              isOpen === true &&
              screen.telasFilhas?.map((item) => {
                if (item.exibir === true && item.menuPrincipal === true && item.nomeTela !== "Principal") {
                  return (<RenderScreen key={item.idTelaSistema} screen={item} />)
                }
                return undefined;
              })
            }
          </div>
        }
      </>

    )
  }

  const RenderModule = ({ modulo }: { modulo: ModuloComTelas }) => {
    const [isOpen, setIsOpen] = useState(modulo.urlTelas?.some(x => x === path))

    return (
      <div className='flex flex-col'>
        <div
          onClick={() => {
            if (isCollapsed === true) {
              setIsCollapsed(false)
            }
            else {
              if (!modulo.telasPai) {
                if (modulo.urlTelas)
                  navigate(modulo.urlTelas[1])
              }
              else {
                setIsOpen(!isOpen)
              }
            }
          }}
          className={bg({ style: isCollapsed === true ? (moduleActive(modulo) ? "activeCollapsed" : "collapsed") : (moduleActive(modulo) ? "activeNotCollapsed" : "notCollapsed") })}>
          <div className='flex items-center gap-3'>
            {
              !modulo.icone ? (
                <DynamicIcon
                  nameIcon={getNameIcon(modulo.descricao)}
                  size={25}
                  className={iconColor({ moduleActive: moduleActive(modulo) })} />
              ) : (
                <Icon
                  sx={{ width: 25, height: 25, fontSize: 20 }}
                  className={`${modulo.icone} ${iconColor({ moduleActive: moduleActive(modulo) })}`} />
              )
            }
            {
              isCollapsed === false &&
              <p className='font-medium'>{modulo.descricao}</p>
            }
          </div>
          {
            (isCollapsed === false && modulo.telasPai && modulo.telasPai?.some(x => x.exibir === true && x.menuPrincipal === true)) &&
            <div>
              <DynamicIcon nameIcon={isOpen ? "KeyboardArrowDownRounded" : "KeyboardArrowRightRounded"} size={25} className={iconColor({ moduleActive: moduleActive(modulo) })} />
            </div>
          }
        </div >
        <div className={`rounded-[4px] bg-light-mode-3 dark:bg-dark-mode-3 mt-1`}>
          {/*
            isOpen === true &&
            modulo.telasPai?.map((item) => {
              // if (item.exibir === true && item.nomeTela !== "Principal") {
              if (item.exibir === true) {
                return (
                  <RenderScreen key={item.idTelaSistema} screen={item} />
                )
              }
              return undefined;
            })
          */}
          {
            isOpen === true &&
            modulo.telasPai?.map((item) => {
              if (item.exibir === true) {
                return (
                  <RenderScreen key={item.idTelaSistema} screen={item} />
                )
              }
              return undefined;
            })
          }
        </div>
      </div>
    )
  }
  return (
    <div className="w-full h-full text-black dark:text-white transition-all duration-100 gap-1 flex flex-col overflow-y-scroll pl-2 py-2 pr-1">
      <div>
        <RenderModule modulo={dashboard} />
      </div>
      {
        screensPermissions.map((item) => (
          <RenderModule key={item.idModuloSistema} modulo={item} />
        ))
      }
    </div>
  );
}

export default NavBarItems;


